import React from 'react'
import useSuperProfileCards from './hooks/useSuperProfileCards'
import s from './styles/SuperProfileCards.module.scss'
import { ReactComponent as SettingsIcon } from 'assets/icons/settings-spark.svg'
import { ReactComponent as TravelIcon } from 'assets/icons/travel_explore.svg'
import { ReactComponent as PsychologyIcon } from 'assets/icons/psychology.svg'
import { ReactComponent as HistoryIcon } from 'assets/icons/history_edu.svg'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'

const CATEGORY_ICON = {
	orientation: <SettingsIcon />,
	interest: <TravelIcon />,
	personality: <HistoryIcon />,
	eq: <PsychologyIcon />,
}

const SuperProfileCards = ({ superProfile = {}, isLoading = false }) => {
	const cards = useSuperProfileCards(superProfile)

	return (
		<section className={s.grid} aria-label="Super Profile">
			{(isLoading ? [...Array(4)].map((_, i) => i + 1) : cards).map(card => (
				<article key={card.key} className={s.card}>
					<span
						className={[s.icon, isLoading && s.loading].filter(Boolean).join(' ')}
						aria-hidden
					>
						{isLoading ? <LoaderImg /> : CATEGORY_ICON[card.key] || null}
					</span>
					<div className={s.body}>
						<p className={s.label}>
							{isLoading ? <LoaderImg /> : card?.categoryLabel}
						</p>
						<p className={s.value}>
							{isLoading ? <LoaderImg /> : card?.archetypeName}
						</p>
					</div>
				</article>
			))}
		</section>
	)
}

export default SuperProfileCards
